import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InformationModalProps } from './InformationModal.types'
import Modal from '../Modal'

const InformationModal: React.FC<InformationModalProps> = ({
  title,
  children,
  closeButton,
  openButton,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()

  const handleOpen = () => setIsOpen(true)
  const handleClose = () => setIsOpen(false)

  // I expected these button will override when it call so no translation on default buttons
  const defaultOpenButton = (
    <button
      onClick={handleOpen}
      className="px-7 py-3 rounded-md text-sm font-medium transition cursor-pointer active-gradient"
    >
      {t('modal.open')}
    </button>
  )

  const defaultCloseButton = (
    <button
      onClick={handleClose}
      className="px-7 py-3 rounded-md text-sm font-medium transition cursor-pointer active-gradient"
    >
      {t('modal.close')}
    </button>
  )

  const footer = closeButton ? closeButton(handleClose) : defaultCloseButton

  return (
    <>
      {openButton ? openButton(handleOpen) : defaultOpenButton}
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title={title}
        footer={footer}
      >
        {children}
      </Modal>
    </>
  )
}

export default InformationModal
